import React from 'react';
import { Typography as MuiTypography } from '@material-ui/core';

const Typography = React.forwardRef(({ ...props }, ref) => <MuiTypography ref={ref} {...props} />);

export default Typography;
